/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Section_SecurityInputs */

const en_settings_section_security = /** @type {(inputs: Settings_Section_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security`)
};

const es_settings_section_security = /** @type {(inputs: Settings_Section_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguridad`)
};

const fr_settings_section_security = /** @type {(inputs: Settings_Section_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sécurité`)
};

const de_settings_section_security = /** @type {(inputs: Settings_Section_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherheit`)
};

const ja_settings_section_security = /** @type {(inputs: Settings_Section_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セキュリティ`)
};

const zh_settings_section_security = /** @type {(inputs: Settings_Section_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全`)
};

const ar_settings_section_security = /** @type {(inputs: Settings_Section_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأمان`)
};

const id_settings_section_security = /** @type {(inputs: Settings_Section_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keamanan`)
};

const it_settings_section_security = /** @type {(inputs: Settings_Section_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicurezza`)
};

const ru_settings_section_security = /** @type {(inputs: Settings_Section_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безопасность`)
};

const pt_settings_section_security = /** @type {(inputs: Settings_Section_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segurança`)
};

const ko_settings_section_security = /** @type {(inputs: Settings_Section_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보안`)
};

/**
* | output |
* | --- |
* | "Security" |
*
* @param {Settings_Section_SecurityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const settings_section_security = /** @type {((inputs?: Settings_Section_SecurityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Section_SecurityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_section_security(inputs)
	if (locale === "es") return es_settings_section_security(inputs)
	if (locale === "fr") return fr_settings_section_security(inputs)
	if (locale === "de") return de_settings_section_security(inputs)
	if (locale === "ja") return ja_settings_section_security(inputs)
	if (locale === "zh") return zh_settings_section_security(inputs)
	if (locale === "ar") return ar_settings_section_security(inputs)
	if (locale === "id") return id_settings_section_security(inputs)
	if (locale === "it") return it_settings_section_security(inputs)
	if (locale === "ru") return ru_settings_section_security(inputs)
	if (locale === "pt") return pt_settings_section_security(inputs)
	return ko_settings_section_security(inputs)
});